import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Overline } from "./Reveal";

export const Interlude = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], [40, -40]);
  const y2 = useTransform(scrollYProgress, [0, 1], [-30, 50]);
  const y3 = useTransform(scrollYProgress, [0, 1], [60, -30]);

  return (
    <section ref={ref} className="relative py-28 sm:py-36 overflow-hidden" data-testid="interlude-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Overline>Inside the Procedure Suite</Overline>
          <h2 className="font-serif-display text-2xl sm:text-3xl lg:text-4xl font-semibold text-stone-800 max-w-3xl leading-snug">
            Precision work, <span className="text-teal-700 italic">captured live.</span>
          </h2>
        </Reveal>
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 items-start">
          <motion.figure style={{ y: y1 }} className="relative rounded-2xl overflow-hidden border border-[#E3DCCB] shadow-[0_30px_80px_-30px_rgba(0,0,0,0.35)]" data-testid="interlude-frame-suite">
            <img src="/assets/ot-suite.webp" alt="Dr. Siddarth Singh's team performing a bronchoscopy procedure in the operation theatre"
              className="w-full aspect-[4/3] object-cover" loading="lazy" />
            <figcaption className="absolute bottom-0 inset-x-0 px-4 pb-4 pt-10 bg-gradient-to-t from-black/50 to-transparent">
              <span className="inline-block px-3 py-1.5 rounded-full bg-[#FAF8F3]/95 backdrop-blur font-mono-tag text-[10px] uppercase tracking-[0.2em] text-stone-800">Live Bronchoscopy — Airway Intervention</span>
            </figcaption>
          </motion.figure>
          <motion.figure style={{ y: y3 }} className="relative rounded-2xl overflow-hidden border border-[#E3DCCB] shadow-[0_30px_80px_-30px_rgba(0,0,0,0.35)] md:mt-12" data-testid="interlude-frame-ebus">
            <img src="/assets/ebus-action.png" alt="Dr. Siddarth Singh performing EBUS (endobronchial ultrasound) with live ultrasound imaging on screen"
              className="w-full aspect-[4/5] object-cover" loading="lazy" />
            <figcaption className="absolute bottom-0 inset-x-0 px-4 pb-4 pt-10 bg-gradient-to-t from-black/50 to-transparent">
              <span className="inline-block px-3 py-1.5 rounded-full bg-[#FAF8F3]/95 backdrop-blur font-mono-tag text-[10px] uppercase tracking-[0.2em] text-stone-800">EBUS — Dr. Singh at the Scope</span>
            </figcaption>
          </motion.figure>
          <motion.figure style={{ y: y2 }} className="relative rounded-2xl overflow-hidden border border-[#E3DCCB] shadow-[0_30px_80px_-30px_rgba(0,0,0,0.35)] md:mt-24" data-testid="interlude-frame-team">
            <img src="/assets/ot-team.png" alt="Interventional pulmonology team in theatre during an advanced airway procedure"
              className="w-full aspect-[4/3] object-cover" loading="lazy" />
            <figcaption className="absolute bottom-0 inset-x-0 px-4 pb-4 pt-10 bg-gradient-to-t from-black/50 to-transparent">
              <span className="inline-block px-3 py-1.5 rounded-full bg-[#FAF8F3]/95 backdrop-blur font-mono-tag text-[10px] uppercase tracking-[0.2em] text-stone-800">The Team — Focused on Every Breath</span>
            </figcaption>
          </motion.figure>
        </div>
      </div>
    </section>
  );
};
